
    import { injectNav, injectFooter } from './src/scripts/layout.js';
    import { initScrollAnimations } from './src/scripts/animations.js';
    document.addEventListener('DOMContentLoaded', () => {
      injectNav();
      injectFooter();
      initScrollAnimations();
    });
  